import { render, staticRenderFns } from "./collaborateDetail.vue?vue&type=template&id=3acc3049&scoped=true&"
import script from "./collaborateDetail.vue?vue&type=script&lang=js&"
export * from "./collaborateDetail.vue?vue&type=script&lang=js&"
import style0 from "./collaborateDetail.vue?vue&type=style&index=0&id=3acc3049&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc3049",
  null
  
)

export default component.exports